<div class="alert-container">
  @for (alert of alerts; track alert.id) {
  <div [ngClass]="getAlertClass(alert)" class="alert-item">
    <!-- Alert Icon -->
    <div class="alert-icon" [ngClass]="getAlertIconClass(alert)">
      @if (alert.type === 'success') {
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" fill="currentColor" />
        <path
          d="M6 10L8.5 12.5L14 7"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      } @if (alert.type === 'warning') {
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 2L18 16H2L10 2Z" fill="currentColor" />
        <path d="M10 7V11" stroke="white" stroke-width="2" stroke-linecap="round" />
        <circle cx="10" cy="13" r="1" fill="white" />
      </svg>
      } @if (alert.type === 'error') {
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" fill="currentColor" />
        <path d="M7 7L13 13M13 7L7 13" stroke="white" stroke-width="2" stroke-linecap="round" />
      </svg>
      } @if (alert.type === 'hint') {
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" fill="currentColor" />
        <path d="M10 6V10" stroke="white" stroke-width="2" stroke-linecap="round" />
        <circle cx="10" cy="13" r="1" fill="white" />
      </svg>
      }
    </div>

    <!-- Alert Content -->
    <div class="alert-content">
      <h4 class="alert-title">{{ alert.title }}</h4>
      <p class="alert-message">{{ alert.message }}</p>

      <!-- Alert Actions -->
      @if (alert.actions && alert.actions.length > 0) {
      <div class="alert-actions">
        <button
          *ngFor="let action of alert.actions"
          class="alert-action-btn"
          (click)="executeAction(action.action)"
        >
          {{ action.text }}
        </button>
      </div>
      }
    </div>

    <!-- Close Button -->
    @if (alert.dismissible) {
    <button class="alert-close" (click)="dismissAlert(alert.id)" aria-label="Close alert">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M12 4L4 12M4 4L12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
    }
  </div>
  }
</div>
